import React from "react";
import Page from "../components/layout/Page";

export default function Cookies() {
  return (
    <Page>
      <div className="page-title">
        <h1>Politică privind utilizarea cookie-urilor</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <article>
            <section>
              <h2>1. Utilizarea cookie-urilor</h2>
              <p>
                Website-ul <strong>asempera.ro</strong> utilizează cookie-uri
                proprii și de la terți pentru a îmbunătăți experiența de
                navigare și pentru a oferi servicii personalizate, adaptate
                nevoilor și intereselor utilizatorilor.
              </p>
              <p>Cookie-urile contribuie la:</p>
              <ul>
                <li>
                  Personalizarea setărilor (ex.: limba de afișare, reținerea
                  datelor de autentificare);
                </li>
                <li>
                  Oferirea de feedback privind utilizarea website-ului pentru
                  îmbunătățirea continuă a acestuia;
                </li>
                <li>
                  Integrarea de aplicații multimedia sau conținut interactiv de
                  la terți pentru o experiență de navigare optimizată.
                </li>
              </ul>
            </section>

            <section>
              <h2>2. Ce este un cookie?</h2>
              <p>
                Un cookie (denumit și „browser cookie” sau „HTTP cookie”) este
                un fișier text de mici dimensiuni, format din litere și cifre,
                stocat pe dispozitivul utilizatorului atunci când acesta
                accesează un website.
              </p>
              <p>
                Cookie-urile sunt pasive, nu conțin software sau viruși și nu
                pot accesa informații de pe hard disk-ul utilizatorului. Acestea
                sunt instalate la solicitarea unui web-server și sunt utilizate
                exclusiv pentru a îmbunătăți experiența utilizatorului pe
                site-ul respectiv.
              </p>
            </section>

            <section>
              <h2>3. Tipuri de cookie-uri</h2>
              <p>Există două categorii principale de cookie-uri:</p>
              <ul>
                <li>
                  <strong>Cookie-uri de sesiune</strong> – stocate temporar în
                  browser și șterse automat la închiderea acestuia;
                </li>
                <li>
                  <strong>Cookie-uri persistente</strong> – stocate pe
                  dispozitiv pentru o perioadă determinată, utilizate pentru a
                  recunoaște utilizatorii la accesările ulterioare.
                </li>
              </ul>
              <p>
                Unele cookie-uri pot fi plasate de terți. Website-ul folosește
                servicii de la terți (precum platforme de analiză, rețele
                sociale, furnizori de publicitate) pentru a personaliza
                conținutul și pentru a analiza comportamentul de navigare.
                Parteneri principali: Google (Google Analytics, Google Ads) și
                Meta (Facebook Pixel și funcționalități de social media).
              </p>
            </section>

            <section>
              <h2>4. Avantajele utilizării cookie-urilor</h2>
              <ul>
                <li>
                  Personalizarea experienței de utilizare (ex.: salvarea
                  preferințelor);
                </li>
                <li>
                  Oferirea unor servicii mai eficiente și adaptate nevoilor
                  utilizatorilor;
                </li>
                <li>Asigurarea securității în timpul navigării;</li>
                <li>Optimizarea performanței website-ului.</li>
              </ul>
            </section>

            <section>
              <h2>5. Durata de viață a cookie-urilor</h2>
              <p>
                Durata de stocare a unui cookie variază în funcție de scopul
                pentru care este utilizat. Unele cookie-uri sunt active doar pe
                durata sesiunii curente, în timp ce altele pot fi reținute
                pentru utilizări ulterioare. Utilizatorii pot șterge manual
                cookie-urile din browser oricând doresc.
              </p>
            </section>

            <section>
              <h2>6. Gestionarea și dezactivarea cookie-urilor</h2>
              <p>
                Utilizatorii își pot configura browserul pentru a bloca,
                restricționa sau șterge cookie-urile. Dezactivarea acestora
                poate afecta funcționalitatea anumitor pagini web.
              </p>
              <p>
                Setările privind cookie-urile pot fi gestionate din meniul
                Opțiuni/Setări al browserului utilizat. Pentru detalii
                suplimentare, consultați instrucțiunile specifice fiecărui
                browser:
              </p>
              <ul>
                <li>
                  <a href="#">Setări cookie-uri în Microsoft Edge</a>
                </li>
                <li>
                  <a href="#">Setări cookie-uri în Firefox</a>
                </li>
                <li>
                  <a href="#">Setări cookie-uri în Chrome</a>
                </li>
                <li>
                  <a href="#">Setări cookie-uri în Safari</a>
                </li>
              </ul>
              <p>Pentru o navigare sigură, se recomandă:</p>
              <ul>
                <li>
                  Personalizarea setărilor browserului pentru a reflecta nivelul
                  dorit de securitate;
                </li>
                <li>
                  Ștergerea regulată a cookie-urilor și a istoricului de
                  navigare;
                </li>
                <li>
                  Utilizarea unor soluții software de protecție împotriva
                  spyware-ului și a amenințărilor cibernetice.
                </li>
              </ul>
            </section>

            <section>
              <h2>7. Contact</h2>
              <p>
                Dacă aveți întrebări suplimentare cu privire la modul în care
                utilizăm modulele cookie, ne puteți contacta la adresa de
                e-mail: <a href="mailto:info@asempera.ro">info@asempera.ro</a>.
              </p>
            </section>
          </article>
        </div>
      </div>
    </Page>
  );
}
